import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { CEUMA_URL_API, BASE } from 'app/config';

export const INSCRICAO_API_URL = CEUMA_URL_API + '/inscricao/';

const API_CURSOS_POS = `${BASE}/pos-graduacao-api/posGraduacao/cursos`;
const API_INSCRICAO_POS = `${BASE}/pos-graduacao-api/posGraduacao/inscricoes`;


@Injectable()
export class InscricaoService {

  private headers: HttpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) { }

  getCursos(tipoCurso): Observable<any> {
    return this.http.get(`${API_CURSOS_POS}?formacao=${tipoCurso}`, { headers: this.headers });
  }

  saveInscricao(data): Observable<any> {
    return this.http.post(`${API_INSCRICAO_POS}`, data, { headers: this.headers });
  }
}
